import enLang from 'validatorjs/src/lang/en';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

const plugins = {
    dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
            validator.setMessages('en', enLang);

            const messages = validator.getMessages('en');
            messages.required = 'You need to enter some information to save';
            validator.setMessages('en', messages);
            
            // Custom rule for non-empty string (after trim)
            validator.register(
                'not_empty_trim',
                (value) => {
                    return (
                        value !== null &&
                        value !== undefined &&
                        typeof value === 'string' &&
                        value.trim().length > 0
                    );
                },
                'This field cannot be empty'
            );
        },
    }),
};

export default plugins;
